import React from 'react'
import Modal from 'react-modal'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'

import OnboardingForm from './OnboardingForm'
import {isCurrentPageOnboardingStandalone} from '../standaloneUtils'

import {closeOnboarding} from '../redux/actions'
import '../../../../scss/components/onboarding/_onboarding.scss'

const OnboardingModal = ({onClose}) => {
  return isCurrentPageOnboardingStandalone() ? null : (
    <Modal
      className="onboarding js--event-reg-modal"
      overlayClassName="modal-overlay"
      isOpen
      onRequestClose={onClose}
      tabIndex="0"
      contentLabel="Modal"
    >
      <OnboardingForm />
    </Modal>
  )
}

OnboardingModal.propTypes = {
  onClose: PropTypes.func,
}

const mapDispatchToProps = {
  onClose: closeOnboarding,
}

export default connect(null, mapDispatchToProps)(OnboardingModal)
